// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3g-uC","title":"ClientInsurance_title__OfT68","itemText":"ClientInsurance_itemText__aIPBY"};